/* eslint-disable no-nested-ternary */
import OptionHOC from '@platform/react/hoc/autocomplete/option'
import OverflowTooltip from 'ui/Element/Text/OverflowTooltip'
import { Box, Typography } from '@mui/material'
import AvatarImage from 'ui/Element/Image/Avatar'

const styles = theme => ({
  content: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
})

/**
 * Displays a Part for the {@link Autocomplete} component. Will display a top label consisting
 * of the type of part (part or assembly) and additionally where it's assembled in. Will also
 * display a sublabel showing its order number, if available.
 *
 * @param {Object} classes  styling for the option
 * @param {Object} props    props for the option
 *
 * @returns {*}
 */
const PartOption = (classes, props = {}) => {
  const { option, labels, ...optionProps } = props || {}

  const {
    orderNumber,
    key = 'item',
    name,
    value,
    image = null,
  } = option || {}

  const { partLabel } = labels || {}
  const { partIcon = 'part' } = optionProps

  const subLabel = orderNumber || null
  const label = name || value || '-'

  const currentAttachment = image?.attachment?.value?.name
    ? { ...image.attachment, key: image?.value?.attachmentId || image.id, api: { ref: 'equipment' } }
    : { value: { name: '' } }

  return (
    <Box
      key={key}
      component={'div'}
      className={classes.content}
    >
      <Box sx={{ width: '40px', marginRight: '16px' }}>
        <AvatarImage
          attachment={currentAttachment}
          icon={{
            name: partIcon,
            color: 'text.regular',
          }}
        />
      </Box>
      <Box className={classes.option}>
        {partLabel && (
          <OverflowTooltip classes={{ label: classes.label }}>
            {partLabel}
          </OverflowTooltip>
        )}
        <OverflowTooltip>
          {label}
        </OverflowTooltip>
        {subLabel && (
          <Typography className={classes.label}>
            {subLabel}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default OptionHOC(PartOption, styles)
